<script setup>
import { get_profile, update_profile } from '@/services/user';
import { onMounted, ref } from 'vue';
import { swalError, swalSuccess } from '@/helper';

const isLoading = ref(true)
const user= ref({})
onMounted(async ()=>{
  let response = await get_profile()
  user.value = response.result.data.data
  isLoading.value = false
})

const isUpdating = ref(false)
async function updateProfile(){
  isUpdating.value = true
  let response = await update_profile(user.value.attributes)
  isUpdating.value = false
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Your profile has been updated')
  localStorage.setItem('user_data', JSON.stringify(response.result.data.data.attributes))
}

</script>
<template>
  <div class="col-xl-8">
    <loadingCard v-if="isLoading" />
    <form v-else class="card" @submit.prevent="updateProfile()">
      <div class="card-header ">
        <h4 class="card-title mb-0">Edit Profile</h4>
        <div class="card-options"><a class="card-options-collapse" href="javascript:void(0)"
          data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove"
          href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">First Name</label>
              <input class="form-control" type="text" placeholder="First name" v-model="user.attributes.first_name">
            </div>
          </div>
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Last Name</label>
              <input class="form-control" type="text" placeholder="Last Name" v-model="user.attributes.last_name">
            </div>
          </div>
          <!-- <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Nickname 
              </label>
              <input class="form-control" type="text" placeholder="Last Name" v-model="user.attributes.last_name">
            </div>
          </div> -->
          <div class="col-sm-6 col-md-6">
            <div class="mb-3">
              <label class="form-label">Alternative email
              </label>
              <input class="form-control" type="text" placeholder="Last Name" v-model="user.attributes.email" disabled>
            </div>
          </div>
          <div class="col-md-12">
            <div>
              <label class="form-label">About Me</label>
              <textarea class="form-control" rows="5" placeholder="Enter About your description"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer text-end">
        <button class="btn btn-primary" type="submit">
          <span v-if="isUpdating">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Updating...</span>
            </div>
          </span>
          <span v-else>
            Update Profile
          </span>
        </button>
      </div>
    </form>
  </div>
</template>